<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="_title">
          <v-icon small>
            mdi-text-box-search-outline
          </v-icon>
          SQL Viewer
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="card-wrap">
          <v-card-title>{{ this.$t('sql.title.ssr') }}</v-card-title>
          <div class="box">
            <table class="section" width="100%">
              <thead>
                <tr>
                  <th width="10%" class="text-left">{{ this.$t('sql.system') }}</th>
                  <th width="10%" class="text-left">{{ this.$t('sql.instance') }}</th>
                  <th width="22%" class="text-left">{{ this.$t('sql.begin') }}</th>
                  <th width="14%" class="text-left">{{ this.$t('sql.end') }}</th>
                  <th width="14%" class="text-left">{{ this.$t('sql.respti') }}</th>
                  <th width="14%" class="text-left">{{ this.$t('sql.db.time') }}</th>
                  <th class="text-left">{{ this.$t('sql.userId') }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><v-text-field :value="step.sstmId" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="step.instShortAlias" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="format(step.starttimestamp, 'yyyy-MM-dd HH:mm:ss')" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="format(step.endtimestamp, 'HH:mm:ss')" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="step.respti | comma" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="step.dbtime | comma" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="step.account" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <table class="section" width="100%">
              <thead>
                <tr>
                  <th width="14%" class="text-left">{{ this.$t('sql.tcode') }}</th>
                  <th width="28%" class="text-left">{{ this.$t('sql.report') }}</th>
                  <th width="28%" class="text-left">{{ this.$t('sql.cua.prog') }}</th>
                  <th class="text-left">{{ this.$t('sql.cua.func') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><v-text-field :value="step.tcode" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="step.adReport" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="step.cuaProg" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="step.cuaFunc" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="card-wrap">
          <v-card-title>{{ this.$t('sql.title.sql.cmd.list') }}</v-card-title>
          <div class="box">
            <!--eslint-disable-next-line prettier/prettier-->
            <v-data-table
              v-model="selectedSqls" :headers="headers" :items="sqls" item-key="startTs" :loading="loading"
              class="elevation-0 content" dense hide-default-footer single-select fixed-header
              @click:row="highlight" height="110" :items-per-page="-1"
            >
              <template v-slot:item.startTime="{ value }">
                {{ format(value, 'yyyy-MM-dd HH:mm:ss') }}
              </template>
              <template v-slot:item.respti="{ value }">
                {{ Math.round(value / 1000) | comma }}
              </template>
            </v-data-table>
            <!--eslint-disable-next-line prettier/prettier-->
            <v-textarea
              :value="selectedSql.command" class="text-full-width" height="178"
              outlined dense hide-details readonly
            />
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card elevation="0" class="mt-2">
          <v-tabs height="35" slider-size="3" :background-color="color(3)" class="rounded-0" show-arrows v-model="selectedTab">
            <v-tab>{{ this.$t('sql.title.sql.context') }}</v-tab>
            <v-tab>{{ this.$t('sql.title.param') }}</v-tab>
            <v-tab>{{ this.$t('sql.title.dbreq') }}</v-tab>
            <v-tab-item transition="false" reverse-transition="false">
              <div class="content-box">
                <fieldset>
                  <legend>
                    <span>{{ this.$t('sql.title.sql.detail') }}</span>
                  </legend>
                  <v-row>
                    <!--eslint-disable-next-line prettier/prettier-->
                    <v-col cols="3"><p class="label">{{ $t('exp.sql.cpu.time') }}</p></v-col>
                    <v-col cols="3"><v-text-field :value="selectedSql.cpuTime | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
                    <!--eslint-disable-next-line prettier/prettier-->
                    <v-col cols="3"><p class="label">{{ $t('exp.sql.records') }}</p></v-col>
                    <v-col cols="3"><v-text-field :value="selectedSql.records | comma" outlined dense hide-details readonly></v-text-field></v-col>
                  </v-row>
                  <v-row>
                    <!--eslint-disable-next-line prettier/prettier-->
                    <v-col cols="3"><p class="label">{{ $t('exp.sql.lw.count') }}</p></v-col>
                    <v-col cols="3"><v-text-field :value="selectedSql.lwCount | comma" outlined dense hide-details readonly></v-text-field></v-col>
                    <!--eslint-disable-next-line prettier/prettier-->
                    <v-col cols="3"><p class="label">{{ $t('exp.sql.lw.duration') }}</p></v-col>
                    <v-col cols="#"><v-text-field :value="selectedSql.lwDuration | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
                  </v-row>
                  <v-row>
                    <!--eslint-disable-next-line prettier/prettier-->
                    <v-col cols="3"><p class="label">{{ $t('exp.sql.mem.size') }}</p></v-col>
                    <v-col cols="3"><v-text-field :value="selectedSql.memSize | comma" outlined dense hide-details readonly></v-text-field></v-col>
                    <!--eslint-disable-next-line prettier/prettier-->
                    <v-col cols="3"><p class="label">{{ $t('exp.sql.re.mem.size') }}</p></v-col>
                    <v-col cols="3"><v-text-field :value="selectedSql.reMemSize | comma" outlined dense hide-details readonly></v-text-field></v-col>
                  </v-row>
                  <v-row>
                    <!--eslint-disable-next-line prettier/prettier-->
                    <v-col cols="3"><p class="label">{{ $t('exp.sql.cmpnt.nm') }}</p></v-col>
                    <v-col cols="3"><v-text-field :value="selectedSql.cmpntNm" outlined dense hide-details readonly></v-text-field></v-col>
                    <!--eslint-disable-next-line prettier/prettier-->
                    <v-col cols="3"><p class="label">{{ $t('exp.sql.app.src') }}</p></v-col>
                    <v-col cols="3"><v-text-field :value="selectedSql.appSrc" outlined dense hide-details readonly></v-text-field></v-col>
                  </v-row>
                  <v-row>
                    <!--eslint-disable-next-line prettier/prettier-->
                    <v-col cols="2"><p class="label">{{ $t('exp.sql.err.code') }}</p></v-col>
                    <v-col cols="1"><v-text-field :value="selectedSql.errCode" outlined dense hide-details readonly></v-text-field></v-col>
                    <v-col cols="9"><v-text-field :value="selectedSql.errText" outlined dense hide-details readonly></v-text-field></v-col>
                  </v-row>
                </fieldset>
                <v-row><v-col cols="12" style="height:29px"></v-col></v-row>
              </div>
              <v-card class="card-wrap">
                <v-card-title>{{ this.$t('sql.title.oper.list') }}</v-card-title>
                <div class="box">
                  <!--eslint-disable-next-line prettier/prettier-->
                  <v-data-table
                    :headers="opersHeaders" :items="selectedSql.operationList" item-key="operation" :loading="loading"
                    height="130" :items-per-page="-1" class="elevation-0 content"
                    dense hide-default-footer single-select fixed-header
                  >
                    <template v-slot:item.duration="{ value }">
                      {{ Math.round(value / 1000) | comma }}
                    </template>
                  </v-data-table>
                </div>
              </v-card>
            </v-tab-item>
            <v-tab-item transition="false" reverse-transition="false">
              <v-card class="card-wrap">
                <v-card-title></v-card-title>
                <div class="box">
                  <!--eslint-disable-next-line prettier/prettier-->
                  <v-data-table
                    :headers="paramsHeaders" :items="selectedSql.parameterList" item-key="seq" :loading="loading"
                    height="366" :items-per-page="-1" class="elevation-0 content"
                    dense hide-default-footer single-select fixed-header
                  />
                </div>
              </v-card>
            </v-tab-item>
            <v-tab-item transition="false" reverse-transition="false" eager>
              <database-tab :step="step"></database-tab>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { api } from '@/api/common/instances';
import { format } from 'date-fns';
import DatabaseTab from '../ssr/DatabaseTab';

export default {
  components: {
    DatabaseTab,
  },
  data() {
    return {
      step: [],
      sqls: [],
      selectedSqls: [],
      selectedSql: {},
      selectedTab: null,
      params: {},
      loading: false,
      itemsPerPage: -1,
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t('sql.begin'), value: 'startTime', sortable: false, width: '20%' },
        { text: this.$t('sql.sql.time'), value: 'respti', sortable: false, align: 'end', width: '16%' },
        { text: this.$t('sql.src.module'), value: 'appSrc', sortable: false },
      ];
    },
    paramsHeaders() {
      return [
        { text: this.$t('sql.param.seq'), value: 'seq', sortable: false, width: '10%' },
        { text: this.$t('sql.param.value'), value: 'value', sortable: false },
      ];
    },
    opersHeaders() {
      return [
        { text: this.$t('sql.oper.name'), value: 'operation', sortable: false, width: '70%' },
        { text: this.$t('sql.oper.duration'), value: 'duration', sortable: false, align: 'end' },
      ];
    },
  },
  watch: {
    selectedSqls(value) {
      this.selectedSql = value[0];
    },
  },
  methods: {
    color(saturation) {
      return this.$vuetify.theme.isDark ? `grey darken-${saturation}` : `grey lighten-${saturation - 2}`;
    },
    highlight(item, { isSelected, select }) {
      // 같은 row를 클릭했을 때는 선택이 풀리지 않도록 리턴...
      if (item.startTs === this.selectedSql.startTs) {
        return;
      }
      select(!isSelected);
    },
    format,
  },
  async created() {
    this.loading = true;
    if ('exp-sql' == this.$route.query.who) {
      ({ data: this.sqls } = await api.get('/analysis/expensive/detail-view', {
        params: {
          startTs: this.$route.query.bgn,
          sstmId: this.$route.query.sid,
          instId: this.$route.query.iid,
          transid: this.$route.query.tid,
        },
      }));

      // 최초 로딩 시에는 첫번째 행이 선택 되도록...
      this.selectedSql = this.sqls[0];
      this.selectedSql.isSelected = true;
      this.selectedSqls.push(this.selectedSql);

      ({ data: this.step } = await api.get('/analysis/expensive/ssr', {
        params: {
          srchBgnYmdhms: this.selectedSql.startTime,
          srchEndYmdhms: this.selectedSql.startTime + parseInt(this.selectedSql.respti / 1000),
          sstmId: this.selectedSql.sstmId,
          mandt: this.selectedSql.mandt,
          account: this.selectedSql.account,
          transid: this.selectedSql.transid,
          wpid: this.selectedSql.wpid,
        },
      }));
    } else {
      ({ data: this.step } = await api.get('/analysis/sqlviewer/ssr', {
        params: {
          bgnYmdhms: parseInt(this.$route.query.bgn),
          sstmId: this.$route.query.sid,
          instId: this.$route.query.iid,
          seq: parseInt(this.$route.query.seq),
        },
      }));
      ({ data: this.sqls } = await api.get('/analysis/sqlviewer/han-exp-stmt-list', {
        params: {
          srchBgnYmdhms: this.step.starttimestamp,
          srchEndYmdhms: this.step.endtimestamp,
          sstmId: this.step.sstmId,
          transid: this.step.transid,
        },
      }));
      if (this.sqls.length == 0) {
        this.selectedTab = 2;
        this.loading = false;
        return;
      }
      // 최초 로딩 시에는 첫번째 행이 선택 되도록...
      this.selectedSql = this.sqls[0];
      this.selectedSql.isSelected = true;
      this.selectedSqls.push(this.selectedSql);
    }
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0 10px 10px 10px;
  margin: 0;
  max-width: 100%;
}
._title {
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2;
}
.section th {
  padding: 0 0 3px 6px;
}
.section td {
  padding: 0 0 0 3px;
}
.text-full-width {
  width: auto;
}
// 이하는 SQL Context Detail 부분을 위해 필요한 것임.
// 2022.06.03.KWShin.
@import '../ssr/tab';
div.input-list * {
  width: 16.6%;
  text-align: left;
}
div.input-list .v-input {
  margin-right: 5px;
}
</style>
